import { formatDateTimeFull } from './constants';

export const leadEventTypeLabels: Record<string, string> = {
  CALL_ATTEMPTED: 'Opkald uden svar',
  STATUS_CHANGED: 'Status opdateret',
  MEETING_CREATED: 'Møde oprettet',
  MEETING_UPDATED: 'Møde opdateret',
  MEETING_CANCELLED: 'Møde annulleret'
};

export const policyStatusLabels: Record<string, string> = {
  PENDING: 'Uploaded',
  COMPLETED: 'Analyseret',
  FAILED: 'Fejlet'
};

export const policyStatusColors: Record<string, string> = {
  PENDING: 'gold',
  COMPLETED: 'green',
  FAILED: 'red'
};

export function formatDateTime(value: string | null | undefined) {
  return formatDateTimeFull(value) ?? '-';
}

export function toLocalInputValue(value: string | null | undefined) {
  if (!value) {
    return undefined;
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return undefined;
  }
  const pad = (input: number) => input.toString().padStart(2, '0');
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}